"use strict"
exports.__esModule = true;
exports.EthereumIconConfig = {
  name: 'EthereumIcon',
  height: 512,
  width: 320,
  svgPath: 'M311.9 260.8L160 353.6 8 260.8 160 0l151.9 260.8zM160 383.4L8 290.6 160 512l152-221.4-152 92.8z',
  yOffset: 0,
  xOffset: 0,
};
exports.EthereumIcon = require('../createIcon').createIcon(exports.EthereumIconConfig);
exports["default"] = exports.EthereumIcon;